import { createApiClient } from '../../../../../api/apiClient';
import { buildOrderRulesRequest } from './requestBuilder';
import { OrderRulesDashboardResponse, OrderRulesFilterParams, OrderRulesSalesVolumeResponse } from './types';

// ─── API: /api/order-rules/sales-volume ──────────────────────────────────────

export const fetchOrderRulesSalesVolume = async (
  params: OrderRulesFilterParams,
  locationIds: string[],
  pagination: { page: number; size: number },
): Promise<OrderRulesSalesVolumeResponse> => {
  const api = createApiClient();
  const body = buildOrderRulesRequest(params, locationIds, pagination);
  const res = await api.post<{ data: OrderRulesSalesVolumeResponse; success: boolean; message: string }>('/order-rules/avg-weekly-sales', body);
  // The endpoint wraps data in { message, data: { records, ... }, success }
  return (res.data as any)?.data ?? res.data;
};

// ─── Normalizer: backend → legacy dashboard shape ────────────────────────────

export const normalizeSalesVolumeResponse = (
  data: OrderRulesSalesVolumeResponse,
): Pick<OrderRulesDashboardResponse, 'salesDetails'> => ({
  salesDetails: (data.records ?? []).map((row) => ({
    region: row.region,
    market: row.market,
    location: row.location,
    customerBp: row.customerBp,
    customer: row.customerName,
    keyAccount: row.keyAccount ?? '-',
    materialNumber: row.materialNo,
    packageName: row.packageName,
    description: row.materialDescription,
    layer: Number(row.casesPerLayer ?? 0),
    avgCases: Number(row.avgCasesPerWk ?? 0),
    potentialCases: 0,
    potentialDeliveries: 0,
  })),
});
